import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translatePhotovoltaicState',
})
export class TranslatePhotovoltaicStatePipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string): string {
    if (value && this.customTranslationsService.PHOTOVOLTAIC_STATES[value]) {
      return this.translateService.instant(
        this.customTranslationsService.PHOTOVOLTAIC_STATES[value] ?? value
      );
    }

    return value;
  }
}
